import _default from './Menu';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Menu/index.js
// module id = 1470
// module chunks = 0